import {
  TextField,
  Box,
  Button,
  InputAdornment,
  IconButton,
} from '@mui/material';
import { useGoogleMap } from '../GoogleMapContext';
import CloseIcon from '@mui/icons-material/Close';

interface GoogleMapTextFieldComponentProps {
  onChange: (event: any) => void;
  onBlur?: (event: any) => void;
  label: string;
  keyName: string;
  name: string;
  isRequired: boolean;
  value: string;
  placeholder?: string;
  errorStr: string;
  disabled?: boolean;
  style?: any;
  type?: string;
  boxStyle?: any;
}
const GoogleMapTextFieldComponent: React.FC<
  GoogleMapTextFieldComponentProps
> = ({
  onChange,
  onBlur,
  boxStyle,
  label,
  isRequired,
  value,
  keyName,
  name,
  placeholder,
  errorStr,
  disabled,
  style,
  type,
}) => {
  const { setIsChoosing, setSiteAddress } = useGoogleMap();
  return (
    <Box
      className="mb-3"
      sx={{ mb: 3 }}
      key={'ele_' + keyName}
      style={{ ...boxStyle, display: 'grid' }}
    >
      <Box sx={{ mb: 1 }} className="form-label" key={'lbk_' + keyName}>
        {label}
        {isRequired && (
          <small style={{ color: 'red' }} key={'sml_' + keyName}>
            {' '}
            *
          </small>
        )}
      </Box>
      <TextField
        type={type ? type : 'text'}
        className="form-control form-control-loum"
        id={keyName}
        name={name}
        label=""
        variant="outlined"
        disabled={disabled}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        style={style}
        fullWidth
        slotProps={{
          input: {
            endAdornment: (
              <InputAdornment position="end">
                {!disabled && (
                  <IconButton size="small" onClick={() => setSiteAddress('')}>
                    <CloseIcon fontSize="inherit" />
                  </IconButton>
                )}
              </InputAdornment>
            ),
          },
        }}
      />
      {errorStr && <span className="bad-field">{errorStr}</span>}
      {!disabled && (
        <Button
          style={{ justifySelf: 'end', textDecoration: 'underline' }}
          onClick={() => setIsChoosing(true)}
        >
          Choose from Google Maps
        </Button>
      )}
    </Box>
  );
};
export default GoogleMapTextFieldComponent;
